(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/models/changeentry.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/models/changeentry.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tur.start_subscription.models.ChangeEntry = svs.tur.start_subscription.models.Entry.extend({
    CONSTANTS: svs.tur.start_subscription.constants,
    defaults: function() {
      return _.extend(typeof this.constructor.__super__.defaults === 'function' ? this.constructor.__super__.defaults() : this.constructor.__super__.defaults, {
        subscriptionEntry: {},
        subscriptionOptions: {},
        subscriptionId: '',
        communicationType: undefined,
        announcement: undefined
      });
    },

    parseEntryOrAnnouncement: function(data) {
      delete data.requestId;
      delete data.requestInfo;

      return {
        announcement: data.announcement,
        amount: data.announcement.intervalAmount,
        communicationType: data.currCommType,
        paymentType: data.paymentType,
        paymentTypeText: this.CONSTANTS.PAYMENT_TYPE[data.paymentType].TEXT,
        payTime: data.paytime,
        isAutogiro: this.CONSTANTS.PAYMENT_TYPE.AUTOGIRO.TYPE === data.paymentType,
        isBankcard: this.CONSTANTS.PAYMENT_TYPE.BANK_CARD.TYPE === data.paymentType
      };
    },

    parseNewSubscription: function(data) {
      delete data.requestId;
      delete data.requestInfo;

      return {
        newSubId: data.subscriptionId
      };
    },

    getEntryOrAnnouncement: function(options) {
      options = options || {};

      var model = this;
      var context = options.context;
      var successCallback = options.success;

      options.success = function(response) {
        var attr = model.parseEntryOrAnnouncement(response);
        model.set(attr);

        svs.components.loader.hide();
        successCallback && successCallback.call(context, model, response, options);
      };

      options.error = model.parseError;

      options.url = svs.core.jupiter.url() + '/subscription/1/replacementannouncement';

      options.attrs = this.get('subscriptionEntry');

      svs.components.loader.show();
      this.sync('create', this, options);
    },

    postNewSubscription: function(options) {
      options = options || {};

      var model = this;
      var context = options.context;
      var successCallback = options.success;

      options.success = function(response) {
        var attr = model.parseNewSubscription(response);
        model.set(attr);

        svs.components.loader.hide();
        successCallback && successCallback.call(context, model, response, options);
      };

      options.error = model.parseError;

      options.url = svs.core.jupiter.url() + '/subscription/2/definesubscription';
      options.attrs = this.get('subscriptionEntry');
      options.attrs.announcement = this.get('announcement');

      svs.components.loader.show();
      this.sync('create', this, options);
    }
  });
})(Backbone, _, svs);

 })(window);